export default __webpack_public_path__ + "static/media/comparison.c26a326e.svg";